import * as React from 'react';

interface IconProps {
  className?: string;
}

export const DiscountIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.38556 15.1847L0.558838 13.358C-0.186279 12.6129 -0.186279 11.3871 0.558838 10.642L2.38556 8.8152C2.69803 8.50273 2.95041 7.88981 2.95041 7.45716V4.87333C2.95041 3.81575 3.81572 2.95041 4.8733 2.95041H7.45717C7.88982 2.95041 8.50274 2.69807 8.81521 2.3856L10.6419 0.558837C11.3871 -0.186279 12.6129 -0.186279 13.358 0.558837L15.1848 2.3856C15.4973 2.69807 16.1101 2.95041 16.5428 2.95041H19.1267C20.1843 2.95041 21.0495 3.81575 21.0495 4.87333V7.45716C21.0495 7.88981 21.3019 8.50273 21.6144 8.8152L23.4412 10.642C24.1863 11.3871 24.1863 12.6129 23.4412 13.358L21.6144 15.1847C21.3019 15.4972 21.0495 16.1101 21.0495 16.5428V19.1267C21.0495 20.1843 20.1843 21.0495 19.1267 21.0495H16.5428C16.1101 21.0495 15.4973 21.3019 15.1848 21.6144L13.358 23.4412C12.6129 24.1863 11.3871 24.1863 10.6419 23.4412L8.81521 21.6144C8.50274 21.3019 7.88982 21.0495 7.45717 21.0495H4.8733C3.81572 21.0495 2.95041 20.1843 2.95041 19.1267V16.5428C2.95041 16.0981 2.69803 15.4852 2.38556 15.1847Z"
      fill="currentColor"
    />
    <path
      d="M15.7498 16.9997C15.0498 16.9997 14.4873 16.4372 14.4873 15.7497C14.4873 15.0622 15.0498 14.4998 15.7373 14.4998C16.4248 14.4998 16.9872 15.0622 16.9872 15.7497C16.9872 16.4372 16.4373 16.9997 15.7498 16.9997Z"
      fill="white"
    />
    <path
      d="M8.26248 9.49993C7.5625 9.49993 7 8.93745 7 8.24997C7 7.56248 7.56248 7 8.24997 7C8.93745 7 9.49993 7.56248 9.49993 8.24997C9.49993 8.93745 8.94996 9.49993 8.26248 9.49993Z"
      fill="white"
    />
    <path
      d="M7.99817 17.0023C7.7447 17.0023 7.49124 16.9089 7.29113 16.7088C6.90426 16.322 6.90426 15.6815 7.29113 15.2947L15.2954 7.2904C15.6823 6.90353 16.3226 6.90353 16.7095 7.2904C17.0964 7.67727 17.0964 8.31769 16.7095 8.70456L8.70521 16.7088C8.50511 16.9089 8.25164 17.0023 7.99817 17.0023Z"
      fill="white"
    />
  </svg>
);

export const DesignToolsIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.8095 3.94012C20.2695 7.78012 16.4095 13.0001 13.1795 15.5901L11.2095 17.1701C10.9595 17.3501 10.7095 17.5101 10.4295 17.6201C10.4295 17.4401 10.4195 17.2401 10.3895 17.0501C10.2795 16.2101 9.89953 15.4301 9.22953 14.7601C8.54953 14.0801 7.71953 13.6801 6.86953 13.5701C6.66953 13.5601 6.46953 13.5401 6.26953 13.5601C6.37953 13.2501 6.54953 12.9601 6.75953 12.7201L8.31953 10.7501C10.8995 7.52012 16.1395 3.64012 19.9695 2.11012C20.5595 1.89012 21.1295 2.05012 21.4895 2.42012C21.8695 2.79012 22.0495 3.36012 21.8095 3.94012Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4303 17.6201C10.4303 18.7201 10.0103 19.77 9.22027 20.57C8.61027 21.18 7.78027 21.6001 6.79027 21.7301L4.33027 22.0001C2.99027 22.1501 1.84027 21.01 2.00027 19.65L2.27027 17.1901C2.51027 15.0001 4.34027 13.6001 6.28027 13.5601C6.48027 13.5501 6.69027 13.56 6.88027 13.57C7.73027 13.68 8.56027 14.0701 9.24027 14.7601C9.91027 15.4301 10.2903 16.21 10.4003 17.05C10.4103 17.24 10.4303 17.4301 10.4303 17.6201Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.24 14.47C14.24 11.86 12.12 9.73999 9.51001 9.73999"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.1197 12.73L20.8597 13.46C22.3497 14.95 22.3497 16.42 20.8597 17.91L17.8997 20.87C16.4297 22.34 14.9397 22.34 13.4697 20.87"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M3.11031 10.5101C1.64031 9.02006 1.64031 7.55006 3.11031 6.06006L6.07031 3.10006C7.54031 1.63006 9.03031 1.63006 10.5003 3.10006L11.2403 3.84006"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M11.25 3.85001L7.55005 7.55001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M20.1199 12.73L17.1599 15.68"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const EditIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8703 10.17L19.2103 8.75005C20.6303 7.25005 21.2703 5.54005 19.0603 3.45005C16.8503 1.37005 15.1803 2.10005 13.7603 3.60005L5.55034 12.29C5.24034 12.62 4.94034 13.27 4.88034 13.72L4.51034 16.96C4.38034 18.13 5.22034 18.93 6.38034 18.73L9.60034 18.18C10.0503 18.1 10.6803 17.77 10.9903 17.43L14.9403 13.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3896 5.05005C12.8196 7.81005 15.0596 9.92005 17.8396 10.2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 22H14.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 22H21.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BuildingIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4997 22.0001H4.07973C2.91973 22.0001 1.96973 21.0701 1.96973 19.9301V5.09011C1.96973 2.47011 3.91973 1.2801 6.30973 2.4501L10.7497 4.63011C11.7097 5.10011 12.4997 6.3501 12.4997 7.4101V22.0001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.97 15.0601V18.8401C21.97 21.0001 20.97 22.0001 18.81 22.0001H12.5V10.4201L12.97 10.5201L17.47 11.5301L19.5 11.9801C20.82 12.2701 21.9 12.9501 21.96 14.8701C21.97 14.9301 21.97 14.9901 21.97 15.0601Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 9.00009H8.97"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 13.0001H8.97"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4697 11.5301V14.7501C17.4697 15.9901 16.4597 17.0001 15.2197 17.0001C13.9797 17.0001 12.9697 15.9901 12.9697 14.7501V10.5201L17.4697 11.5301Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9597 14.8702C21.8997 16.0502 20.9197 17.0002 19.7197 17.0002C18.4797 17.0002 17.4697 15.9902 17.4697 14.7502V11.5302L19.4997 11.9802C20.8197 12.2702 21.8997 12.9502 21.9597 14.8702Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HouseIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 22H22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.94995 22L2.99995 9.96999C2.99995 9.35999 3.28995 8.78004 3.76995 8.40004L10.77 2.95003C11.49 2.39003 12.4999 2.39003 13.2299 2.95003L20.23 8.39003C20.72 8.77003 21 9.34999 21 9.96999V22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M13 17H11C10.17 17 9.5 17.67 9.5 18.5V22H14.5V18.5C14.5 17.67 13.83 17 13 17Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 13.75H7.5C6.95 13.75 6.5 13.3 6.5 12.75V11.25C6.5 10.7 6.95 10.25 7.5 10.25H9.5C10.05 10.25 10.5 10.7 10.5 11.25V12.75C10.5 13.3 10.05 13.75 9.5 13.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M16.5 13.75H14.5C13.95 13.75 13.5 13.3 13.5 12.75V11.25C13.5 10.7 13.95 10.25 14.5 10.25H16.5C17.05 10.25 17.5 10.7 17.5 11.25V12.75C17.5 13.3 17.05 13.75 16.5 13.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinejoin="round"
    />
    <path
      d="M19.0003 7L18.9703 4H14.5703"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CakeIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 22H22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.11035 22V13C3.11035 11.34 4.60035 10 6.44035 10H17.5504C19.3904 10 20.8804 11.34 20.8804 13V22"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.55957 10V7.17C5.55957 5.97 6.63957 5 7.97957 5H16.0296C17.3596 5 18.4396 5.97 18.4396 7.17V10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.53027 13.98L3.90027 13.99C4.64027 14 5.23027 14.6 5.23027 15.34V15.67C5.23027 16.41 5.83027 17.02 6.58027 17.02C7.32027 17.02 7.93027 16.42 7.93027 15.67V15.36C7.93027 14.62 8.53027 14.01 9.28027 14.01C10.0203 14.01 10.6303 14.61 10.6303 15.36V15.67C10.6303 16.41 11.2303 17.02 11.9803 17.02C12.7203 17.02 13.3303 16.42 13.3303 15.67V15.36C13.3303 14.62 13.9303 14.01 14.6803 14.01C15.4203 14.01 16.0303 14.61 16.0303 15.36V15.67C16.0303 16.41 16.6303 17.02 17.3803 17.02C18.1203 17.02 18.7303 16.42 18.7303 15.67V15.36C18.7303 14.62 19.3303 14.01 20.0803 14.01H20.5303"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5V3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 5V3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5V2"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BottleIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 15V19C18 20.65 16.65 22 15 22H9C7.35 22 6 20.65 6 19V13.98L9.89001 14C10.62 14 11.34 14.17 12 14.5C12.66 14.83 13.38 15 14.12 15H18Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 10.83V15H14.12C13.38 15 12.66 14.83 12 14.5C11.34 14.17 10.62 14 9.89001 14L6 13.98V10.83C6 10.37 6.26003 9.74 6.59003 9.41L8.71002 7.28999C8.89002 7.10999 9 6.85 9 6.59V5H15V6.59C15 6.85 15.11 7.10999 15.29 7.28999L17.41 9.41C17.74 9.74 18 10.37 18 10.83Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 16V15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 14.98V13.98"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5 5H9.5C8.67 5 8 4.32 8 3.5C8 2.68 8.67 2 9.5 2H14.5C15.33 2 16 2.68 16 3.5C16 4.32 15.33 5 14.5 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GalleryIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 22H15.5C20.5 22 22.5 20 22.5 15V9C22.5 4 20.5 2 15.5 2H9.5C4.5 2 2.5 4 2.5 9V15C2.5 20 4.5 22 9.5 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 10C10.6046 10 11.5 9.10457 11.5 8C11.5 6.89543 10.6046 6 9.5 6C8.39543 6 7.5 6.89543 7.5 8C7.5 9.10457 8.39543 10 9.5 10Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.16992 18.95L8.09992 15.64C8.88992 15.11 10.0299 15.17 10.7399 15.78L11.0699 16.07C11.8499 16.74 13.1099 16.74 13.8899 16.07L18.0499 12.5C18.8299 11.83 20.0899 11.83 20.8699 12.5L22.4999 13.9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MagicStarIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0259 22.5C12.4259 22.5 11.4959 22.21 10.6059 20.75L8.8459 17.9C8.6759 17.62 8.15589 17.35 7.83589 17.37L4.49586 17.54C2.49586 17.64 1.79591 16.81 1.54591 16.31C1.29591 15.81 1.07587 14.74 2.37587 13.22L4.35591 10.92C4.55591 10.68 4.66588 10.16 4.57588 9.86002L3.56587 6.63004C3.05587 5.01004 3.62587 4.14004 4.00587 3.76004C4.38587 3.38004 5.26588 2.83003 6.88588 3.37003L9.83589 4.34003C10.1059 4.43003 10.6059 4.35003 10.8359 4.19003L13.9159 1.97003C15.3259 0.950032 16.3459 1.22003 16.8159 1.47003C17.2859 1.72003 18.0859 2.40005 18.0559 4.14005L17.9859 7.93002C17.9759 8.21002 18.2059 8.67003 18.4259 8.84003L20.9059 10.72C22.2559 11.75 22.3059 12.78 22.2159 13.31C22.1259 13.84 21.7259 14.8 20.1059 15.3L16.8759 16.31C16.5759 16.4 16.2059 16.79 16.1259 17.09L15.3559 20.03C14.8459 21.96 13.8459 22.39 13.2859 22.47C13.2159 22.49 13.1259 22.5 13.0259 22.5ZM7.86586 15.87C8.72586 15.87 9.67586 16.39 10.1159 17.11L11.8759 19.96C12.3759 20.78 12.8259 21.03 13.0659 20.99C13.2959 20.96 13.6559 20.58 13.9059 19.66L14.6759 16.72C14.8859 15.92 15.6359 15.13 16.4259 14.89L19.6559 13.88C20.2759 13.69 20.6759 13.38 20.7359 13.06C20.7959 12.74 20.5159 12.32 19.9959 11.92L17.5159 10.04C16.9059 9.58004 16.4659 8.66002 16.4759 7.90002L16.5459 4.11002C16.5559 3.44002 16.3959 2.94004 16.1059 2.79004C15.8159 2.64004 15.3259 2.79002 14.7759 3.18002L11.6959 5.40002C11.0859 5.84002 10.0759 6.00004 9.3459 5.76004L6.39588 4.79004C5.77589 4.59004 5.27591 4.60002 5.04591 4.83002C4.81591 5.06002 4.79585 5.56002 4.98585 6.18002L5.99586 9.41003C6.24586 10.2 6.02585 11.27 5.48585 11.89L3.50587 14.19C2.87587 14.92 2.77588 15.43 2.88588 15.64C2.98588 15.85 3.4659 16.08 4.4159 16.03L7.75587 15.86C7.79587 15.87 7.83586 15.87 7.86586 15.87Z"
      fill="currentColor"
    />
    <path
      d="M21.9259 22.7502C21.7359 22.7502 21.546 22.6802 21.396 22.5302L18.3659 19.5002C18.0759 19.2102 18.0759 18.7302 18.3659 18.4402C18.6559 18.1502 19.1359 18.1502 19.4259 18.4402L22.456 21.4702C22.746 21.7602 22.746 22.2402 22.456 22.5302C22.306 22.6802 22.1159 22.7502 21.9259 22.7502Z"
      fill="currentColor"
    />
  </svg>
);

export const GiftIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9697 10H3.96973V18C3.96973 21 4.96973 22 7.96973 22H15.9697C18.9697 22 19.9697 21 19.9697 18V10Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.5 7V8C21.5 9.1 20.97 10 19.5 10H4.5C2.97 10 2.5 9.1 2.5 8V7C2.5 5.9 2.97 5 4.5 5H19.5C20.97 5 21.5 5.9 21.5 7Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.64 5H6.12003C5.78003 4.63 5.79003 4.06 6.15003 3.7L7.57003 2.28C7.94003 1.91 8.55003 1.91 8.92003 2.28L11.64 5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8696 4.99994H12.3496L15.0696 2.27994C15.4396 1.90994 16.0496 1.90994 16.4196 2.27994L17.8396 3.69994C18.1996 4.05994 18.2096 4.62994 17.8696 4.99994Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.94043 10V15.14C8.94043 15.94 9.82043 16.41 10.4904 15.98L11.4304 15.36C11.7704 15.14 12.2004 15.14 12.5304 15.36L13.4204 15.96C14.0804 16.4 14.9704 15.93 14.9704 15.13V10H8.94043Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.93994 13.28L10.2866 8.93333C10.7999 8.42 10.7999 7.58 10.2866 7.06667L5.93994 2.72"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SchoolBagIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 200 255.7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M154.6,255.7H45.1c-19.1,0-33.1-17.5-33.1-35.7v-99.7C4.2,115.9,0,108.6,0,99.9v-36C.2,44.2,15.9,29.4,35.3,29.4h32.8C69.8,12.1,83.5.3,99.5,0c16.5-.3,30.6,11.9,32.4,29.3h33.6c19.1.2,34.2,15.3,34.4,34.5v37.1c0,8.3-4.7,15.1-12,19.4v100.7c-.1,17.8-14.7,34.7-33.4,34.7ZM116.8,29.3c-2.1-9.9-9.7-14.8-18.2-14.3-7.4.5-14.3,6.3-15.4,14.4h33.6ZM129.4,108l.2-15.5c0-5,4.5-7.4,8.9-6.8s6.1,3.9,6.1,8.4v13.8s31.5.1,31.5.1c5.1,0,8.9-2.7,9-8.1v-35.3c0-8.3-6.1-19.6-16.1-19.6H31.1c-10.1,0-16.1,11.4-16.1,19.6v35.3c0,4.6,3.3,8,8,8h32.4s.3-16.3.3-16.3c0-4.6,5.1-6.5,8.7-6s6.1,3.9,6.2,8.4v13.8s58.9,0,58.9,0ZM144.5,123v30.5c0,4.8-3.6,8.1-8,7.9s-7-3.4-7-7.9v-30.6s-58.9,0-58.9,0v30.6c0,4.8-3.6,8.1-8,7.9s-7.1-3.9-7.1-8.7v-29.7c0,0-28.4,0-28.4,0v87.4s20.2,0,20.2,0c-.9-8.5-.2-15.4,4.8-21.7,4-5,10.6-8.3,18.3-8.3h60.2c12.5,0,22.3,10,22.4,22.4v7.6c0,0,20-.1,20-.1v-87.4s-28.5,0-28.5,0ZM137.9,210.4v-8.6c0-3.1-3.6-6.1-6.9-6.1h-62.1c-3.2,0-6.8,2.9-6.8,6.1v8.6s75.8,0,75.8,0ZM154.5,240.8c9,0,15.4-7.6,17.8-15.1H27.7c2.5,8,9.5,15.1,18.3,15.1h108.4Z"
      fill="currentColor"
    />
  </svg>
);

export const OfficeIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M90.6,210v30.9c-.1,0,6.5,0,6.5,0,4.4,0,7.9,2.5,8.4,6.9s-2.8,8.2-7.4,8.2h-30.1c-4.3,0-7.5-3.9-7.4-7.5s3.7-7.6,8.4-7.6h6.6s0-30.9,0-30.9h-38.5c-3.3,0-6.5-4.3-6.5-7.3v-15.4c0-12.3,10-22.2,22.4-22.2h22.5c0,0,0-15.1,0-15.1h-36.5c-3.9,0-8-2.1-8.2-6.7l-.3-8.3h-15.3s0,113.8,0,113.8c0,4.3-4.1,7.2-7.5,7.2S0,253.2,0,248.8v-120.8c0-4.9,3.3-8,8-8h22.5s0-36.8,0-36.8c0-18.2,8.8-34.5,22.9-44,15.7-10.6,34.4-12.1,52-4.3l.2-27.6C105.6,3.3,108.9,0,113.1,0h120.8c3.6,0,6.6,4,6.6,7.4v90.2c0,4.1-3.5,7.5-7.4,7.5h-52.5s0,15,0,15h68.4c3.5,0,7,3.4,7,7.1v121.7c0,4.4-4.1,7.2-7.5,7.2s-7.4-3-7.4-7.1v-24c0,0-75.5,0-75.5,0v23.6c-.1,4.1-3.6,7.2-7.1,7.4s-8-2.9-8-7.5v-113.4s-14.9-.1-14.9-.1v7.8c-.2,2.9-3.1,7.2-6.5,7.2h-38.5c0,0,0,15,0,15h22.5c12.4,0,22.4,10,22.4,22.3v15.4c0,3-3.1,7.2-6.4,7.2h-38.5ZM225.5,90V15s-104.9,0-104.9,0v30.9c11.9,11.8,16.1,27.5,14.8,44.1h90.1ZM120.5,135l-.2-54.1c0-20.7-18-36.1-37.8-35.9-19.4.2-36.7,15.5-36.8,35.9l-.2,54.1h75ZM165.5,104.9h-29.9v15.1h29.9v-15.1ZM241,134.9h-75.5v30.1h75.5v-30.1ZM120.3,195v-8.2c.1-3.8-3.6-6.8-7.3-6.8h-60.1c-3,0-7.1,2.7-7.2,5.8v9.2c0,0,74.5,0,74.5,0ZM241,179.9h-75.5v30.1h75.5v-30.1Z"
      fill="currentColor"
    />
  </svg>
);

export const ToysIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 259.7 259.8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M144.4,259.8c-5.9,0-10.4-1.7-14.5-4.5-4.1,2.8-8.7,4.5-13.9,4.5H17.4C7.6,259.6,0,250.5,0,241.1v-98.7c0-8.9,6.7-18.3,16.2-18.4l46.3-.3-.7-9.1V18.6C61.8,8.6,69.7,0,80,0h99.7c10.3,0,18.2,8.6,18.2,18.6v96.1s-.7,9.1-.7,9.1l46.3.3c9.5,0,16.2,9.5,16.2,18.4v98.7c0,9.4-7.6,18.5-17.4,18.5h-98ZM179,123.8c4.1,0,6.6-3.5,6.6-6.9V18.5c0-3.2-2.7-5.7-5.8-6h-99.6c-3.2.3-5.8,2.8-5.8,6v98.4c0,4,3.1,6.9,7.1,6.9h97.7ZM117.1,247.3c3.5,0,6.6-2.9,6.6-6.4v-99.1c-.6-3.2-2.7-5.2-5.9-5.8H18.8c-3.6,0-6.4,3-6.4,6.5v98.6c0,3.4,2.8,6.2,6.2,6.2h98.6ZM241.7,247.3c3.4-.6,5.6-3.2,5.6-6.2v-98.6c0-3.6-2.8-6.5-6.4-6.5h-99c-3.2.6-5.3,2.6-5.9,5.8v99.1c0,3.6,3.1,6.4,6.6,6.4h99.1Z"
      fill="currentColor"
    />
    <path
      d="M222.8,228.7h-61.7c-1.7,0-5.1-1.8-5.7-3.3s-.4-4.2.1-6.3l30.9-61.9c1.4-1.2,4.1-2.8,5.5-2.9s4.5,2.2,5.6,3.9l31,62c0,1.7-.2,4.3-.5,5.5s-3.6,2.9-5.2,2.9ZM212.5,216.3l-20.8-41.8-21,41.9h41.8Z"
      fill="currentColor"
    />
    <path
      d="M130,95.1l-19.4,8.6c-1.3.6-4.7.4-5.8-.3s-3.1-4.2-2.9-5.8l2.1-21.1-14-15.9c-.9-1.1-1.8-4-1.6-5.3s2.5-4.2,4.2-4.6l21-4.6,11.1-18.6c.7-1.2,3.4-2.7,4.7-2.9s4.7,1.3,5.5,2.7l10.8,18.5,20.7,4.7c1.6.4,4.2,2.4,4.7,3.9s-.3,4.9-1.4,6.1l-14.1,16,2.1,21c.1,1.4-1.2,4.5-2.2,5.4s-4.9,1.6-6.4.9l-19.2-8.7ZM130,81.9l14.3,5.8-1.2-15.4,10.1-11.9-15.1-3.7-8.2-13.4-8.2,13.4-15.1,3.7,10,11.9-1.1,15.3,14.4-5.7Z"
      fill="currentColor"
    />
    <path
      d="M105.1,191.6c0,20.5-16.6,37.1-37.1,37.1s-37.1-16.6-37.1-37.1,16.6-37.1,37.1-37.1,37.1,16.6,37.1,37.1ZM92.8,191.7c0-13.7-11.1-24.7-24.7-24.7s-24.7,11.1-24.7,24.7,11.1,24.7,24.7,24.7,24.7-11.1,24.7-24.7Z"
      fill="currentColor"
    />
  </svg>
);

export const BooksIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 256 231.7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M246.1,231.2c-39.5-13.4-78.8-10.3-118.1.4-39.5-10.8-78.6-13.7-117.7-.6-2.5.4-5.3.2-7.2-1S0,226.1,0,223.5V41.8c0-2.8,1.7-6.1,3.9-7.1,8.7-3.9,16.6-6.8,26-9.4v-13.7c0-3.9,2.5-6.7,6.3-7.9,30.5-8.5,70.1-2.9,91.8,21.8C149.6.8,189.2-4.8,219.8,3.7c3.1,1,6.1,3.7,6.1,6.9l.2,14.7c9.6,2.6,17.7,5.6,26.6,9.8s3.3,4.4,3.3,6.7v181.7c0,2.2-1.3,5.2-2.5,6.1s-4.5,1.9-7.4,1.6ZM120.4,201.9V42.7c-11.5-25.5-48.8-31-75.4-25.8v162.7c8.8-1.3,17.2-1.1,25.9.3,18.3,3.1,33.9,11.2,49.5,22ZM179.7,181c10.8-2.3,20.7-3,31.2-1.4V16.8c-25.6-5.3-65.2,1-75.5,25.9v159.5c14-10.1,27.8-17.4,44.2-21.2ZM38.6,196.2c-3.7.9-8.5-2.4-8.5-6.7V40.8c-5.9,2-10.3,3.6-15,5.6v167.6c29.7-8.4,59.4-8.1,91-3.1-19-14.2-42.5-21-67.5-14.7ZM149.9,210.9c31.7-5,61.4-5.3,91.1,3.1V46s-15-5.3-15-5.3v146.8c0,2.8-.9,5.5-2.6,7s-4.8,2.1-6.7,1.6c-10.1-2.8-19.5-3.1-29.7-1.4-13.4,2.8-26.3,7.7-37.1,16.2Z"
      fill="currentColor"
    />
  </svg>
);

export const DrawingIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 256 256.1"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M255.8,190.7c.9,35.4-27.2,63.9-61.3,65.3-34.5,1.4-64-24.8-66.6-60.5l-60.5,60.4-58.5.2c-4.7.4-8.4-2.5-9-7.2l.2-60.5,60.4-60.4L13.4,80.7C-5.2,62-4,31.8,14.3,13.8s48.3-18.5,67,0l46.8,46.7,47.3-47.1c18.7-18.6,49-17.3,66.9.8,18.5,18.7,18.4,48.7-.5,67.6l-67.3,67.4c23,2.8,39,20.5,39.3,42.9s6.5,13.6,13.8,13.6,13.3-5.9,13.5-13.8,3.2-6.9,6.9-7.4,7.9,1.6,8,6.1ZM117.4,71.1l-47.2-47.2c-13.5-12.2-33.4-11.7-45.9,1s-12.9,32.5-.3,45.2l47.1,47.3,46.2-46.3ZM222.6,79.7l9.1-9.1c12.5-13,12.4-33.1,0-45.8-12.2-12.5-32.8-13.5-45.7-.9l-9.7,9.5,46.3,46.3ZM165.6,44l-17.7,17.7,46.4,46.4,17.7-17.7-46.4-46.4ZM165.5,101l-107.6,107.6c-3.8,2.3-8,1.4-10.3-1.8s-2.1-6.9.8-9.8l106.8-106.8-17.9-17.8L18.1,191.6l46.3,46.2,119.2-119.2-18.1-17.6ZM231.7,220.6c-17.5,2.2-32.8-10.7-33-28.5s-14.1-29-30-27.7c-16.2,1.3-27.2,15.2-25.6,31.6s15.8,37,34.3,42.8,41.5-.7,54.3-18.2ZM25.2,241.2l21-.3-31.1-31v21.6c0,0,10,9.7,10,9.7Z"
      fill="currentColor"
    />
  </svg>
);

export const HowToLearnIcon: React.FC<IconProps> = ({ className }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 248 248"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M143.2,247.6c-13,.6-24.6.4-36.8.2s-24-12.3-23.9-25.7v-15.5c.1,0-16.4,0-16.4,0-5.4,0-9.1-5-8.1-9.8,1-5,5.4-7.9,12.2-6.4v-12.8c0-9.4-4.7-16.8-10.8-22.9C20.4,115.3,25.6,51.6,68.8,18.6,111.9-14.4,175.3-2.3,202.5,45.4c20.2,35.3,15.4,79.4-13.4,108.6-6.7,6.8-11.6,14.4-11.5,24.7v11.6c6.5-1.1,10.5,1.2,12,5.8s-1.5,10.2-6.8,10.3l-17.6.2-.3,18.6c-.2,10.9-10,21.7-21.7,22.3ZM87,190h74.8c-3.2-20.2,3.8-35.8,16.6-48.9,28.6-29.3,25.8-76.7-3-104.2-29.2-27.8-75.1-27.2-103.7,1.1-28.3,27.9-29.9,74.4-1.5,103.6,10.5,10.8,16.2,23.3,16.7,39.2l.3,9.2ZM142,231.3c4.7-1.2,6.8-5,6.8-9.3v-15.5c0,0-49.6,0-49.6,0v16.6c0,4.1,3.2,7.6,7.2,8.2h35.6Z"
      fill="currentColor"
    />
    <path
      d="M27.9,41.7c4.7,2.3,6.3,6.7,4.7,10.9-1.6,4.1-6.7,6.7-11.2,4.4l-16.5-8.2c-4.2-2.1-5.8-6.6-4.2-10.7s6.6-6.6,11.1-4.4l16.2,8Z"
      fill="currentColor"
    />
    <path
      d="M11.7,148c-4.2,2.1-8.9,0-10.8-3.8-2.1-4.1-.5-9.1,3.9-11.4l16.5-8.2c4.1-2,9.1,0,10.8,3.7s.8,8.9-3.3,11l-17.2,8.6Z"
      fill="currentColor"
    />
    <path
      d="M242.7,132.6c4.7,2.3,6.3,6.7,4.7,10.9s-6.7,6.7-11.2,4.4l-16.5-8.2c-4.2-2.1-5.7-6.6-4.2-10.7s6.6-6.6,11.1-4.4l16.2,8Z"
      fill="currentColor"
    />
    <path
      d="M226.2,57.3c-4.8,1.4-9.2-.9-10.7-4.8s0-8.5,4.2-10.6l16.5-8.2c4.1-2,9.1,0,10.8,3.6s.8,8.9-3.3,11l-17.5,8.9Z"
      fill="currentColor"
    />
    <path
      d="M16.1,99.2h-6.9c-4.7.1-8.3-2.6-9.1-7s1.6-8.8,6.3-9.3,8.1-.4,12,0,6.6,5.1,6.4,8.4-3.4,7.9-8.7,7.9Z"
      fill="currentColor"
    />
    <path
      d="M239.3,99.2h-6.9c-4.7.1-8.3-2.6-9.1-7s1.6-8.8,6.3-9.3,8.1-.4,12,0,6.6,5.1,6.4,8.4-3.4,7.9-8.7,7.9Z"
      fill="currentColor"
    />
    <path
      d="M163.7,128.9c-13.3-.4-25,3.7-35.7,10.5s-6.5,1.3-8.9-.3c-11-7.3-23.3-10.5-36.3-10.4-5,0-8.5-4.2-8.5-9v-58.8c.6-4.3,4-7.2,8.2-7.3,14.7-.3,28.2,3.1,41.5,10.2,12.6-7.1,25.9-10.1,40.2-10.2,5,0,9.1,3,9.2,8.3v57.8c0,5.4-3.9,9.4-9.8,9.2ZM115.7,118.4v-40.2c-7.6-4.2-15.8-6.6-24.8-7.6v41.8c9,1.3,16.9,3.2,24.8,6.1ZM132.3,118.5c8.7-3.1,16.1-5,24.8-6.1v-41.8c-8.6,1-16.9,3.4-24.8,7.8v40.1Z"
      fill="currentColor"
    />
  </svg>
);
